import KendoDataSourceBase from '../KendoDataSourceBase'
import GanttDependencyDataSourceProps from './GanttDependencyDataSourceProps'

import Schema from './Schema'

export default {
    props: GanttDependencyDataSourceProps,
    mixins: [
        KendoDataSourceBase, 
        Schema
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.GanttDependencyDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDependencyDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDependencyDataSource/KendoGanttDependencyDataSourceMixin.js